import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import './TeamSharePoster.css';

function clampText(s, max = 72) {
  const t = (s || '').toString().trim();
  if (!t) return '';
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}

export default function TeamSharePoster({
  teamName,
  teamNumber,
  division,
  rank,
  totalPoints,
  photoUrl,
  shareUrl,
  brandName = 'Fresh Meet',
}) {
  const [qrDataUrl, setQrDataUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function gen() {
      if (!shareUrl) { setQrDataUrl(''); return; }
      try {
        const u = await QRCode.toDataURL(shareUrl, {
          margin: 0,
          width: 220,
          color: { dark: '#E6FFFB', light: '#00000000' },
        });
        if (!cancelled) setQrDataUrl(u);
      } catch {
        if (!cancelled) setQrDataUrl('');
      }
    }
    gen();
    return () => { cancelled = true; };
  }, [shareUrl]);

  const tname = clampText(teamName || `Team ${teamNumber}`, 46);
  const divisionRank = rank != null ? `Division rank #${rank}` : '';

  return (
    <div className="team-share-poster" data-poster>
      <div className="team-share-poster-bg" aria-hidden />

      <section className="team-share-poster-stage">
        <div className="team-share-poster-photo" aria-hidden>
          {photoUrl ? (
            <img src={photoUrl} alt="" crossOrigin="anonymous" />
          ) : (
            <div className="team-share-poster-photo-placeholder" aria-hidden />
          )}
        </div>

        <div className="team-share-poster-badges" aria-label="Results">
          <div className="team-share-poster-badge team-share-poster-badge--primary">
            <div className="team-share-poster-badge-label">Total score</div>
            <div className="team-share-poster-badge-value">{totalPoints ?? '—'}</div>
            <div className="team-share-poster-badge-sub">pts</div>
          </div>
        </div>

        <section className="team-share-poster-team" aria-label="Team">
          <div className="team-share-poster-teamname">{tname}</div>
          {divisionRank ? <div className="team-share-poster-teammeta">{divisionRank}</div> : null}
        </section>

        <footer className="team-share-poster-footer">
          <div className="team-share-poster-brand">
            <img className="team-share-poster-brandmark" src="/fresh-meet-logo.png" alt="" />
            <div className="team-share-poster-brandtext">{brandName}</div>
          </div>

          <div className="team-share-poster-link">
            {qrDataUrl ? <img className="team-share-poster-qr" src={qrDataUrl} alt="" /> : null}
          </div>
        </footer>
      </section>
    </div>
  );
}

